// Categories that contain order-flow tools rather than indicator-only products.
// These IDs match the site's seeded category groups.
const orderFlowCategoryIds = new Set([1, 2, 3, 4, 5, 6, 9, 12]);

export function getSubscriptionAccessMessage(categoryId: number | null | undefined): string {
  return orderFlowCategoryIds.has(categoryId ?? -1)
    ? "Subscription includes all indicators & order flow tools"
    : "Subscription includes all indicators";
}